
//import RSIUpgradeHero from '@share/assets/images/profiles/rsi-getaways-prime.jpg';

const RSIUpgrade = 'https://membergetawaysprime.com/assets/BWhiteLabel/img/805/Logo.svg';

import RsiGetaways1 from '@share/assets/images/profiles/rsi-getaways-1.jpg';
import RsiGetaways2 from '@share/assets/images/profiles/rsi-getaways-2.jpg';
import RsiGetaways3 from '@share/assets/images/profiles/rsi-getaways-3.jpg';
import RsiGetaways4 from '@share/assets/images/profiles/rsi-getaways-4.jpg';
import RsiGetaways5 from '@share/assets/images/profiles/rsi-getaways-5.jpg';
import RsiGetaways6 from '@share/assets/images/profiles/rsi-getaways-6.jpg';
import RsiGetaways7 from '@share/assets/images/profiles/rsi-getaways-7.jpg';
import RsiGetaways8 from '@share/assets/images/profiles/rsi-getaways-8.jpg';
import RsiGetaways9 from '@share/assets/images/profiles/rsi-getaways-9.jpg';
import RsiGetaways10 from '@share/assets/images/profiles/rsi-getaways-10.jpg';
import RsiGetaways11 from '@share/assets/images/profiles/rsi-getaways-11.jpg';

export const RSIUpgradePrimeProfile = {
    logo: RSIUpgrade,
    logoSkipWidth: true,

    headerFontColor: '#FFFFFF',
    headerBackgroundColor: '#1A1D6E',

    buttonColor: '#1A1D6E',
    buttonTextColor: '#FFFFFF',

    buttonColorReverse: '#FFFFFF',
    buttonTextColorReverse: '#1A1D6E',

    buttonBorderRadius: '0',

    generalBorderRadius: '0',
    generalBorderColor: '#0079C2',
    
    isTravelLeadersImage: true,
    travelLeadersImages: [
        { value : RsiGetaways1 },
        { value : RsiGetaways2 },
        { value : RsiGetaways3 },
        { value : RsiGetaways4 },
        { value : RsiGetaways5 },
        { value : RsiGetaways6 },
        { value : RsiGetaways7 },
        { value : RsiGetaways8 },
        { value : RsiGetaways9 },
        { value : RsiGetaways10 },
        { value : RsiGetaways11 },
    ],
    travelLeadersImageBackground: '#1A1D6E',
    travelLeadersImageText: 'rsi.upgrade.prime.hero.text',
    travelLeadersImageTextColor: '#FFFFFF',
    travelLeadersImageTextFamily: 'liu-jian-mao-cao-font',
    travelLeadersImageTextPosition: 'bottom-under',

    bogoColor: '#323232',
    bogoButtonTextColor: '#1A1D6E',
    getawaysColor: '#1A1D6E',
    getawaysButtonTextColor: '#1A1D6E',

    buttonColorAlternative: '#CFA241',
    buttonTextColorAlternative: '#FFFFFF',

    mainBackgroundColor: '#1A1D6E',
    subHeaderColor: '#000000',
    travelLeadersFontSize: '50',

    mainBorderColor: '#6D6D6D',
    mainBorderRadius: '0',
    mainHideLinkIcon: true,

    menuItemHideBorderBottom: true
}
